<template>
  <div id="printable" class="summary-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">MOH 711 - MONTHLY INPATIENT SUMMARY</div>
    </div>

    <!-- Month/Year and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="info-item">
          <span class="info-label">Month:</span>
          <select v-model="selectedMonth" class="month-select">
            <option value="January">January</option>
            <option value="February">February</option>
            <option value="March">March</option>
            <option value="April">April</option>
            <option value="May">May</option>
            <option value="June">June</option>
            <option value="July">July</option>
            <option value="August">August</option>
            <option value="September">September</option>
            <option value="October">October</option>
            <option value="November">November</option>
            <option value="December">December</option>
          </select>
        </div>
        <div class="info-item">
          <span class="info-label">Year:</span>
          <input
            type="number"
            v-model="selectedYear"
            class="year-input"
            min="2020"
            max="2030"
          />
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">🖨️ Print Summary</button>
    </div>

    <!-- Period Display for Print -->
    <div class="print-period">
      <strong>Reporting Period:</strong> {{ selectedMonth }} {{ selectedYear }}
    </div>

    <!-- Section A: Bed Occupancy -->
    <div class="section">
      <div class="section-title">A. BED OCCUPANCY</div>
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-label">Number of Beds in Ward</div>
          <div class="stat-value">{{ bedOccupancy.numberOfBeds }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Total Bed Days Available</div>
          <div class="stat-value">{{ bedOccupancy.totalBedDaysAvailable }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Total Bed Days Used</div>
          <div class="stat-value">{{ bedOccupancy.totalBedDaysUsed }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Bed Occupancy Rate (%)</div>
          <div class="stat-value">{{ bedOccupancy.bedOccupancyRate }}%</div>
        </div>
      </div>
    </div>

    <!-- Section B: Admissions and Discharges -->
    <div class="section">
      <div class="section-title">B. ADMISSIONS AND DISCHARGES</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Under 5</th>
              <th>5+ Years</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Admissions (Male)</td>
              <td>{{ admissions.maleUnder5 }}</td>
              <td>{{ admissions.maleOver5 }}</td>
              <td>{{ admissions.maleUnder5 + admissions.maleOver5 }}</td>
            </tr>
            <tr>
              <td>Admissions (Female)</td>
              <td>{{ admissions.femaleUnder5 }}</td>
              <td>{{ admissions.femaleOver5 }}</td>
              <td>{{ admissions.femaleUnder5 + admissions.femaleOver5 }}</td>
            </tr>
            <tr class="total-row">
              <td>Total Admissions</td>
              <td>{{ admissions.maleUnder5 + admissions.femaleUnder5 }}</td>
              <td>{{ admissions.maleOver5 + admissions.femaleOver5 }}</td>
              <td>{{ totalAdmissions }}</td>
            </tr>
            <tr>
              <td>Discharges (Male)</td>
              <td>{{ discharges.maleUnder5 }}</td>
              <td>{{ discharges.maleOver5 }}</td>
              <td>{{ discharges.maleUnder5 + discharges.maleOver5 }}</td>
            </tr>
            <tr>
              <td>Discharges (Female)</td>
              <td>{{ discharges.femaleUnder5 }}</td>
              <td>{{ discharges.femaleOver5 }}</td>
              <td>{{ discharges.femaleUnder5 + discharges.femaleOver5 }}</td>
            </tr>
            <tr class="total-row">
              <td>Total Discharges</td>
              <td>{{ discharges.maleUnder5 + discharges.femaleUnder5 }}</td>
              <td>{{ discharges.maleOver5 + discharges.femaleOver5 }}</td>
              <td>{{ totalDischarges }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section C: Deaths -->
    <div class="section">
      <div class="section-title">C. DEATHS</div>
      <div class="table-wrapper">
        <table class="data-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Under 5</th>
              <th>5+ Years</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Deaths (Male)</td>
              <td>{{ deaths.maleUnder5 }}</td>
              <td>{{ deaths.maleOver5 }}</td>
              <td>{{ deaths.maleUnder5 + deaths.maleOver5 }}</td>
            </tr>
            <tr>
              <td>Deaths (Female)</td>
              <td>{{ deaths.femaleUnder5 }}</td>
              <td>{{ deaths.femaleOver5 }}</td>
              <td>{{ deaths.femaleUnder5 + deaths.femaleOver5 }}</td>
            </tr>
            <tr class="total-row">
              <td>Total Deaths</td>
              <td>{{ deaths.maleUnder5 + deaths.femaleUnder5 }}</td>
              <td>{{ deaths.maleOver5 + deaths.femaleOver5 }}</td>
              <td>{{ totalDeaths }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Section D: Referrals -->
    <div class="section">
      <div class="section-title">D. REFERRALS</div>
      <div class="stats-grid-2">
        <div class="stat-card">
          <div class="stat-label">Referrals In</div>
          <div class="stat-value">{{ referrals.referralsIn }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Referrals Out</div>
          <div class="stat-value">{{ referrals.referralsOut }}</div>
        </div>
      </div>
    </div>

    <!-- Section E: Length of Stay -->
    <div class="section">
      <div class="section-title">E. LENGTH OF STAY</div>
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-label">Total Patient Days</div>
          <div class="stat-value">{{ lengthOfStay.totalPatientDays }}</div>
        </div>
        <div class="stat-card">
          <div class="stat-label">Average Length of Stay (days)</div>
          <div class="stat-value">{{ lengthOfStay.avgLengthOfStay }}</div>
        </div>
      </div>
    </div>

    <!-- Section F: Top 10 Diagnoses -->
    <div class="section">
      <div class="section-title">F. TOP 10 DIAGNOSES (by frequency)</div>
      <div class="table-wrapper">
        <table class="diagnosis-table">
          <thead>
            <tr>
              <th>Rank</th>
              <th>Diagnosis</th>
              <th>Number of Cases</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(diagnosis, index) in topDiagnoses" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ diagnosis.name }}</td>
              <td>{{ diagnosis.count }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH711Summary",
  data() {
    return {
      selectedMonth: "April",
      selectedYear: 2026,
      generatedBy: "SR. JANE KAREGI MUNYUGI",

      // Bed Occupancy Data
      bedOccupancy: {
        numberOfBeds: 40,
        totalBedDaysAvailable: 1200,
        totalBedDaysUsed: 985,
        bedOccupancyRate: 82.1,
      },

      // Admissions Data
      admissions: {
        maleUnder5: 45,
        maleOver5: 78,
        femaleUnder5: 52,
        femaleOver5: 89,
      },

      // Discharges Data
      discharges: {
        maleUnder5: 42,
        maleOver5: 75,
        femaleUnder5: 48,
        femaleOver5: 85,
      },

      // Deaths Data
      deaths: {
        maleUnder5: 3,
        maleOver5: 5,
        femaleUnder5: 2,
        femaleOver5: 4,
      },

      // Referrals Data
      referrals: {
        referralsIn: 28,
        referralsOut: 35,
      },

      // Length of Stay Data
      lengthOfStay: {
        totalPatientDays: 985,
        avgLengthOfStay: 7.2,
      },

      // Top Diagnoses
      topDiagnoses: [
        { name: "Malaria (Confirmed)", count: 156 },
        { name: "Pneumonia", count: 98 },
        { name: "Upper Respiratory Tract Infection", count: 87 },
        { name: "Diarrhoea with dehydration", count: 65 },
        { name: "Hypertension", count: 54 },
        { name: "Diabetes Mellitus", count: 43 },
        { name: "Gastroenteritis", count: 38 },
        { name: "Anaemia", count: 32 },
        { name: "Urinary Tract Infection", count: 29 },
        { name: "Typhoid Fever", count: 24 },
      ],
    };
  },
  computed: {
    totalAdmissions() {
      return (
        this.admissions.maleUnder5 +
        this.admissions.maleOver5 +
        this.admissions.femaleUnder5 +
        this.admissions.femaleOver5
      );
    },
    totalDischarges() {
      return (
        this.discharges.maleUnder5 +
        this.discharges.maleOver5 +
        this.discharges.femaleUnder5 +
        this.discharges.femaleOver5
      );
    },
    totalDeaths() {
      return (
        this.deaths.maleUnder5 +
        this.deaths.maleOver5 +
        this.deaths.femaleUnder5 +
        this.deaths.femaleOver5
      );
    },
  },
  methods: {
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.summary-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Header */
.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

/* Info Bar */
.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.month-select {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  background: white;
}

.year-input {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  width: 70px;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-print:hover {
  background: #2563eb;
}

/* Print Period */
.print-period {
  text-align: center;
  padding: 8px;
  margin-bottom: 20px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

/* Sections */
.section {
  margin-bottom: 28px;
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  color: #1f2937;
  background: #e5e7eb;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 12px;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 10px;
}

.stats-grid-2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  max-width: 500px;
}

.stat-card {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  padding: 12px 16px;
  text-align: center;
}

.stat-label {
  font-size: 11px;
  font-weight: 600;
  color: #166534;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #059669;
}

/* Tables */
.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.data-table th {
  background: #1f2937;
  color: white;
  padding: 8px;
  text-align: center;
  border: 1px solid #374151;
}

.data-table td {
  border: 1px solid #d1d5db;
  padding: 8px;
  text-align: center;
}

.data-table td:first-child {
  text-align: left;
  font-weight: 500;
}

.total-row {
  background: #fef3c7;
  font-weight: bold;
}

.diagnosis-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.diagnosis-table th {
  background: #1f2937;
  color: white;
  padding: 8px;
  text-align: center;
  border: 1px solid #374151;
}

.diagnosis-table td {
  border: 1px solid #d1d5db;
  padding: 8px;
}

.diagnosis-table td:first-child {
  text-align: center;
  width: 60px;
}

.diagnosis-table td:last-child {
  text-align: center;
  width: 120px;
}

/* Print Styles */
@media print {
  @page {
    size: portrait;
    margin: 0.5cm;
  }

  .btn-print,
  .month-select,
  .year-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-period {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .section-title {
    font-size: 11px;
    padding: 4px 8px;
  }

  .stat-value {
    font-size: 18px;
  }

  .stat-label {
    font-size: 9px;
  }

  .data-table,
  .diagnosis-table {
    font-size: 9px;
  }

  .data-table th,
  .data-table td,
  .diagnosis-table th,
  .diagnosis-table td {
    padding: 4px;
  }
}
</style>
